import { useEnum } from "@/api/services/global/enum";
import { CheckboxGroup } from "@/components/elements/CheckboxGroup";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { TUserSettingForm } from "@/features/user-setting/types/UserSettingForm";
import { black, divider } from "@/theme/colors";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TEmailDeliveryFormProps = {};

export const EmailDeliveryForm: FC<TEmailDeliveryFormProps> = () => {
  const methods = useFormContext<TUserSettingForm>();
  const { data: emailDeliveryOptions } = useEnum("EEmailDelivery");
  const { control } = methods;

  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="sub16Bold" color={black[30]}>
          アカウント情報
        </Typography>
      </Stack>

      <Grid mt={2} container gap="4px" columnSpacing="20px">
        <Grid item xs={12}>
          <FormField control={control} name="emailDeliveryOptions">
            <CheckboxGroup options={emailDeliveryOptions} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
